export const intervalAvailabilities = new Map([
  [0, 'Только сотрудникам'],
  [1, 'Доступно всем'],
]);

export const defaultIntervalAvailability = 1;
